<template>
  <b-row>
    <b-col cols="6" sm="4" class="col-key text-left text-sm-right">
      {{ rowKey }}
    </b-col>
    <b-col cols="6" sm="8" class="col-value">
      <div
        v-if="isBoolean"
        class="badge"
        :class="{
          'badge-success': isBooleanAndTrue,
          'badge-secondary': !isBooleanAndTrue,
        }"
      >
        <strong>{{ processedRowValue }}</strong>
      </div>
      <strong v-if="!isBoolean">{{ processedRowValue }}</strong>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'DetailModalRow',
  props: ['rowKey', 'rowValue', 'booleanType'],
  computed: {
    isBoolean() {
      return typeof this.booleanType !== 'undefined' && this.booleanType === true;
    },
    isBooleanAndTrue() {
      return this.isBoolean && this.rowValue === 1;
    },
    processedRowValue() {
      if (this.isBoolean) {
        if (this.isBooleanAndTrue) {
          return 'Yes';
        }
        return 'No';
      }
      return this.rowValue;
    },
  },
  data: function() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.row {
  margin-top: 1px;
}

.col-key,
.col-value {
  padding-top: 2px;
  padding-bottom: 2px;
  @media all and (max-device-width: 576px) {
    font-size: 0.8rem;
  }
}

.col-key {
  border-right: 1px solid #ffffff;
  background-color: #e1e1e1;
}

.col-value {
  background-color: #f1f1f1;
}
</style>
